// hooks/useOpenCv.js
import { useEffect, useState } from 'react';

export function useOpenCv(shouldLoad) {
  const [ready, setReady] = useState(!!window.cv?.Mat);

  useEffect(() => {
    if (!shouldLoad || ready) return;

    // si un altre component ja l'ha demanat, no el tornem a injectar
    if (document.getElementById('opencv-script')) return;

    const script = document.createElement('script');
    script.id = 'opencv-script';
    script.src = 'https://docs.opencv.org/4.x/opencv.js';
    script.async = true;
    script.onload = () => {
      // opencv.js crida aquest callback quan el WASM ja està a punt
      window.cv.onRuntimeInitialized = () => setReady(true);
    };
    document.body.appendChild(script);
  }, [shouldLoad, ready]);

  return ready;
}